import Request from '../../shared/utils/_request'

class System {
  constructor() {

  }
  //组织架构树
  getRoleList() {
    return Request.post('/account/role/get-all')
  }
  createRole(payload) {
    return Request.post('/account/role/create', payload)
  }
  changeRoleStatus(payload) {
    return Request.post('/account/role/change-status', payload)
  }
  updateRole(payload) {
    return Request.post('/account/role/update', payload)
  }
  deleteRole(payload) {
    return Request.post('/account/role/delete', payload)
  }
  //权限
  getUserPermission(){
    return Request.post('/account/role-permission/getUserAll')
  }
  getPermissionTree(){
    return Request.post('/common/permission-menu/get-tree')
  }
  getRolePermission(payload) {
    return Request.post('/account/role-permission/get-all', payload)
  }

  updateRolePermission(payload) {
    return Request.post('/account/role-permission/save',payload)
  }

  //白名单
  whiteList(payload) {
    return Request.post('/system/ip-white/get-list', payload)
  }
  /**
   * @param {{ip,description}} payload
   */
  whiteCreate(payload) {
    return Request.post('/system/ip-white/create', payload)
  }
  /**
   * @param {{ip,description}} payload
   */
  whiteUpdate(payload) {
    return Request.post('/system/ip-white/update', payload)
  }
  /**
   * @param {{id}} payload
   */
  whiteDelete(payload) {
    return Request.post('/system/ip-white/delete', payload)
  }
}

export const system = new System()